import React from "react";

interface MenuSupplementTagProps {
    id: number;
    label: React.ReactNode;
    onRemove: (id: number) => void;
    onEdit: (id: number) => void;
    disabled?: boolean;
    canEditSupplement?: boolean;
}

const DishSupplementTag: React.FC<MenuSupplementTagProps> = ({
    id,
    label,
    onRemove,
    onEdit,
    disabled = false,
    canEditSupplement = false,
}) => {
    const handleEditClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (!canEditSupplement) return;
        onEdit(id);
    };

    const handleRemoveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onRemove(id);
    };

    return (
        <span className="menu-supplement-tag fs-7 rounded-1 bg-violet-light text-primary d-inline-flex align-items-center p-2 py-1">
            {canEditSupplement ? (
                <button
                    type="button"
                    className="menu-supplement-tag__label btn p-0 border-0 text-primary text-decoration-none"
                    onClick={handleEditClick}
                    disabled={disabled}
                >
                    {label}
                </button>
            ) : (
                <span className="menu-supplement-tag__label">{label}</span>
            )}

            <button
                type="button"
                aria-label="Remove supplement group"
                className="menu-supplement-tag__remove btn p-0 border-0 text-primary text-decoration-none ms-2"
                onClick={handleRemoveClick}
                disabled={disabled}
            >
                <i className="bi bi-x-lg" />
            </button>
        </span>
    );
};

export default DishSupplementTag;
